import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Header from '../../components/header';
import HeaderBackButton from '../../components/header-back-button';
import SearchHeader from './search-header';
import withFontClassName from '../../hoc/with-font-class-name';

const SearchMobileHeader = ({ contentFontClassName, ...otherProps }) =>
  <SearchHeader
    component={Header}
    left={<HeaderBackButton text={''}/>}
    inputClassName={classNames('button-primary-text-color', contentFontClassName)}
    borderClassName="button-primary-text-background-color"
    iconClassName="button-primary-icon-fill"
    showWidget={false}
    {...otherProps}
  />;

SearchMobileHeader.propTypes = {
  contentFontClassName: PropTypes.string.isRequired,
};

export default withFontClassName(SearchMobileHeader);



// WEBPACK FOOTER //
// ./app/containers/search-header/search-mobile-header.js